(() => {
  const STORAGE_KEY = "mindelor:search-history:v1";
  const MAX_SEARCHES = 8;

  const normalizeQuery = (value) => value.replace(/\s+/g, " ").trim().slice(0, 120);
  const queryKey = (value) => value.toLocaleLowerCase("nl-NL");

  const getStoredSearches = () => {
    try {
      const storedSearches = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");

      if (!Array.isArray(storedSearches)) {
        return [];
      }

      const uniqueSearches = new Map();

      storedSearches.forEach((value) => {
        if (typeof value !== "string") {
          return;
        }

        const query = normalizeQuery(value);

        if (query && !uniqueSearches.has(queryKey(query))) {
          uniqueSearches.set(queryKey(query), query);
        }
      });

      return Array.from(uniqueSearches.values()).slice(0, MAX_SEARCHES);
    } catch (error) {
      return [];
    }
  };

  const setStoredSearches = (searches) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(searches.slice(0, MAX_SEARCHES)));
    } catch (error) {
    }
  };

  const rememberSearch = (value) => {
    const query = normalizeQuery(value);

    if (!query) {
      return getStoredSearches();
    }

    const searches = getStoredSearches().filter((storedQuery) => queryKey(storedQuery) !== queryKey(query));
    searches.unshift(query);
    setStoredSearches(searches);

    return searches;
  };

  const removeSearch = (value) => {
    const key = queryKey(normalizeQuery(value));
    const searches = getStoredSearches().filter((storedQuery) => queryKey(storedQuery) !== key);
    setStoredSearches(searches);

    return searches;
  };

  const createClockIcon = () => {
    const namespace = "http://www.w3.org/2000/svg";
    const icon = document.createElementNS(namespace, "svg");
    const circle = document.createElementNS(namespace, "circle");
    const path = document.createElementNS(namespace, "path");

    icon.setAttribute("viewBox", "0 0 24 24");
    icon.setAttribute("width", "18");
    icon.setAttribute("height", "18");
    icon.setAttribute("fill", "none");
    icon.setAttribute("aria-hidden", "true");
    circle.setAttribute("cx", "12");
    circle.setAttribute("cy", "12");
    circle.setAttribute("r", "8.5");
    circle.setAttribute("stroke", "currentColor");
    circle.setAttribute("stroke-width", "1.5");
    path.setAttribute("d", "M12 7.75v4.75l3 1.75");
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "1.5");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    icon.append(circle, path);

    return icon;
  };

  const installStyles = () => {
    if (document.getElementById("mindelor-search-history-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "mindelor-search-history-styles";
    style.textContent = `
      .mindelor-search-history[hidden] {
        display: none !important;
      }

      header-search predictive-search[data-mindelor-history-visible] {
        display: none;
      }

      .mindelor-search-history {
        max-width: min(72rem, calc(100vw - 6rem));
        margin-inline: auto;
        padding-block: 1.125rem 1.5rem;
      }

      .mindelor-search-history__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-block-end: .75rem;
      }

      .mindelor-search-history__title {
        color: #1c1c1c;
        font-size: .75rem;
        font-weight: 600;
        line-height: 1.3;
        letter-spacing: .08em;
        text-transform: uppercase;
      }

      .mindelor-search-history__clear {
        min-height: 2.25rem;
        color: #8f6f3e;
        border-radius: 999px;
        padding-inline: .625rem;
        font-size: .75rem;
        font-weight: 600;
        line-height: 1.2;
      }

      .mindelor-search-history__list {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: .625rem;
      }

      .mindelor-search-history__item {
        min-width: 0;
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        overflow: hidden;
        color: #1c1c1c;
        background: rgba(255, 253, 249, .84);
        border: 1px solid rgba(200, 169, 106, .24);
        border-radius: 12px;
        box-shadow: 0 10px 26px rgba(28, 28, 28, .035);
        transition: border-color .2s ease, background-color .2s ease, box-shadow .2s ease;
      }

      .mindelor-search-history__query {
        min-width: 0;
        min-height: 3rem;
        display: flex;
        align-items: center;
        gap: .625rem;
        padding: .6875rem .75rem;
        text-align: start;
      }

      .mindelor-search-history__query svg {
        flex: 0 0 auto;
        color: rgba(28, 28, 28, .48);
      }

      .mindelor-search-history__query-text {
        min-width: 0;
        overflow: hidden;
        color: rgba(28, 28, 28, .82);
        font-size: .875rem;
        line-height: 1.4;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .mindelor-search-history__remove {
        box-sizing: border-box;
        width: var(--mindelor-search-close-size, 2.5rem);
        height: var(--mindelor-search-close-size, 2.5rem);
        min-width: var(--mindelor-search-close-size, 2.5rem);
        min-height: var(--mindelor-search-close-size, 2.5rem);
        display: grid;
        place-items: center;
        align-self: center;
        padding: 0;
        color: #1c1c1c;
        background: var(--mindelor-search-close-background, rgba(255, 253, 249, .82));
        border: 1px solid var(--mindelor-search-close-border, rgba(200, 169, 106, .24));
        /* Keep icon buttons round despite the theme's global button corners. */
        border-radius: var(--rounded-full, 999px) !important;
        box-shadow: var(--mindelor-search-close-shadow, 0 10px 24px rgba(28, 28, 28, .06));
        margin-inline-end: .25rem;
        opacity: 1;
        touch-action: manipulation;
        transition: background-color .2s, border-color .2s, box-shadow .2s, color .2s, transform .2s;
        line-height: 1;
      }

      .mindelor-search-history__remove > svg {
        width: var(--mindelor-search-close-icon-size, 1rem);
        height: var(--mindelor-search-close-icon-size, 1rem);
        display: block;
      }

      .mindelor-search-history button:focus-visible {
        outline: 2px solid rgba(143, 111, 62, .55);
        outline-offset: 2px;
      }

      .mindelor-search-history .mindelor-search-history__remove:focus-visible {
        outline-color: rgba(182, 142, 101, .42);
      }

      .mindelor-search-history__remove:active {
        background: #f5f5f5;
        transform: translateY(1px);
      }

      @media (hover: hover) {
        .mindelor-search-history__item:hover {
          background: #fffaf2;
          border-color: rgba(200, 169, 106, .42);
          box-shadow: 0 12px 28px rgba(28, 28, 28, .05);
        }

        .mindelor-search-history__clear:hover {
          color: #1c1c1c;
          background: rgba(200, 169, 106, .1);
        }
      }

      @media screen and (pointer: fine) {
        .mindelor-search-history__remove:hover {
          color: #1c1c1c;
          background: #ffffff;
          border-color: rgba(201, 166, 70, .5);
          box-shadow: 0 12px 26px rgba(28, 28, 28, .1);
        }
      }

      @media screen and (max-width: 999px) {
        .mindelor-search-history {
          max-width: none;
        }
      }

      @media screen and (max-width: 699px) {
        .mindelor-search-history {
          padding-block: 1rem .5rem;
        }

        .mindelor-search-history__list {
          grid-template-columns: minmax(0, 1fr);
        }
      }
    `;
    document.head.append(style);
  };

  const setupSearchHistory = (headerSearch) => {
    if (!headerSearch || headerSearch._mindelorSearchHistoryReady) {
      return;
    }

    const form = headerSearch.querySelector('form[role="search"]');
    const input = form?.elements?.q;
    const predictiveSearch = headerSearch.querySelector("predictive-search");
    const closeIcon = form?.querySelector("dialog-close-button svg");

    if (!form || !input || !predictiveSearch) {
      return;
    }

    headerSearch._mindelorSearchHistoryReady = true;

    const history = document.createElement("section");
    const historyHeader = document.createElement("div");
    const title = document.createElement("p");
    const clearButton = document.createElement("button");
    const list = document.createElement("ul");
    const status = document.createElement("p");
    const historyId = `${headerSearch.id || "header-search"}-history`;

    history.className = "mindelor-search-history";
    history.id = historyId;
    history.hidden = true;
    history.setAttribute("aria-labelledby", `${historyId}-title`);
    historyHeader.className = "mindelor-search-history__header";
    title.className = "mindelor-search-history__title";
    title.id = `${historyId}-title`;
    title.textContent = "Recente zoekopdrachten";
    clearButton.className = "mindelor-search-history__clear";
    clearButton.type = "button";
    clearButton.textContent = "Alles wissen";
    list.className = "mindelor-search-history__list";
    status.className = "sr-only";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    historyHeader.append(title, clearButton);
    history.append(historyHeader, list);
    form.insertAdjacentElement("afterend", history);
    history.insertAdjacentElement("afterend", status);

    const announce = (message) => {
      status.textContent = "";
      requestAnimationFrame(() => {
        status.textContent = message;
      });
    };

    const isVisible = () => !history.hidden;

    const moveHistoryFocus = (currentButton, direction) => {
      const buttons = Array.from(list.querySelectorAll(".mindelor-search-history__query"));
      const currentIndex = buttons.indexOf(currentButton);
      const nextButton = buttons[currentIndex + direction];

      if (nextButton) {
        nextButton.focus();
      } else if (direction < 0) {
        input.focus();
      }
    };

    const runRecentSearch = (query) => {
      rememberSearch(query);
      input.value = query;
      history.hidden = true;
      predictiveSearch.removeAttribute("data-mindelor-history-visible");
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.focus({ preventScroll: true });
    };

    const updateVisibility = () => {
      const searches = getStoredSearches();
      const shouldShow = headerSearch.hasAttribute("open") && normalizeQuery(input.value) === "" && searches.length > 0;

      history.hidden = !shouldShow;
      predictiveSearch.toggleAttribute("data-mindelor-history-visible", shouldShow);
    };

    const render = () => {
      const searches = getStoredSearches();
      const fragment = document.createDocumentFragment();

      searches.forEach((query) => {
        const item = document.createElement("li");
        const queryButton = document.createElement("button");
        const queryText = document.createElement("span");
        const removeButton = document.createElement("button");

        item.className = "mindelor-search-history__item";
        queryButton.className = "mindelor-search-history__query";
        queryButton.type = "button";
        queryText.className = "mindelor-search-history__query-text";
        queryText.textContent = query;
        removeButton.className = "mindelor-search-history__remove";
        removeButton.type = "button";
        removeButton.setAttribute("aria-label", `Verwijder “${query}” uit recente zoekopdrachten`);
        removeButton.innerHTML = closeIcon?.outerHTML || '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"/></svg>';
        queryButton.append(createClockIcon(), queryText);
        queryButton.addEventListener("click", () => runRecentSearch(query));
        queryButton.addEventListener("keydown", (event) => {
          if (event.key === "ArrowDown") {
            event.preventDefault();
            moveHistoryFocus(queryButton, 1);
          } else if (event.key === "ArrowUp") {
            event.preventDefault();
            moveHistoryFocus(queryButton, -1);
          }
        });
        removeButton.addEventListener("click", () => {
          const nextSearches = removeSearch(query);
          render();
          announce("Zoekopdracht verwijderd.");

          if (nextSearches.length > 0) {
            list.querySelector(".mindelor-search-history__query")?.focus();
          } else {
            input.focus();
          }
        });
        item.append(queryButton, removeButton);
        fragment.append(item);
      });

      list.replaceChildren(fragment);
      clearButton.hidden = searches.length === 0;
      updateVisibility();
    };

    form.addEventListener("submit", () => {
      rememberSearch(input.value);
      render();
    });
    input.addEventListener("focus", render);
    input.addEventListener("input", updateVisibility);
    input.addEventListener("keydown", (event) => {
      if (event.key === "ArrowDown" && isVisible()) {
        const firstQuery = list.querySelector(".mindelor-search-history__query");

        if (firstQuery) {
          event.preventDefault();
          firstQuery.focus();
        }
      }
    });
    predictiveSearch.addEventListener("click", (event) => {
      if (event.target.closest?.("a[href]")) {
        rememberSearch(input.value);
      }
    }, { capture: true });
    clearButton.addEventListener("click", () => {
      setStoredSearches([]);
      render();
      announce("Zoekgeschiedenis gewist.");
      input.focus();
    });
    headerSearch.addEventListener("dialog:after-show", render);
    headerSearch.addEventListener("dialog:after-hide", updateVisibility);
    window.addEventListener("storage", (event) => {
      if (event.key === STORAGE_KEY) {
        render();
      }
    });

    render();
  };

  const setupAllSearchHistories = () => {
    document.querySelectorAll("header-search").forEach(setupSearchHistory);
  };

  installStyles();
  setupAllSearchHistories();
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("header-search").forEach(setupSearchHistory);
  });
})();
